export default "/images/2203f0493ab5fe367ff81387a996d648.avif";